export function getLocalTime2(time) {
  const nS = new Date(time)
  let year = nS.getFullYear() // 取得4位数的年份
  let month = nS.getMonth() + 1 // 取得日期中的月份，其中0表示1月，11表示12月
  let date = nS.getDate() // 返回日期月份中的天数（1到31）
  let hour = nS.getHours() // 返回日期中的小时数（0到23）
  let minute = nS.getMinutes() // 返回日期中的分钟数（0到59）
  let second = nS.getSeconds() // 返回日期中的秒数（0到59）
  month = month < 10 ? '0' + month : month
  date = date < 10 ? '0' + date : date
  hour = hour < 10 ? '0' + hour : hour
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return year + '_' + month + '_' + date + '_' + hour + ':' + minute + ':' + second
}
export function getLocalTime4(time) {
  const nS = new Date(time)
  let year = nS.getFullYear() // 取得4位数的年份
  let month = nS.getMonth() + 1 // 取得日期中的月份，其中0表示1月，11表示12月
  let date = nS.getDate() // 返回日期月份中的天数（1到31）
  // let hour = nS.getHours() // 返回日期中的小时数（0到23）
  // let minute = nS.getMinutes() // 返回日期中的分钟数（0到59）
  // let second = nS.getSeconds() // 返回日期中的秒数（0到59）
  month = month < 10 ? '0' + month : month
  date = date < 10 ? '0' + date : date
  // hour = hour < 10 ? '0' + hour : hour
  // minute = minute < 10 ? '0' + minute : minute
  // second = second < 10 ? '0' + second : second
  return year + '.' + month + '.' + date
}
export function getLocalTime(time) {
  const nS = new Date(time)
  let year = nS.getFullYear() // 取得4位数的年份
  let month = nS.getMonth() + 1 // 取得日期中的月份，其中0表示1月，11表示12月
  let date = nS.getDate() // 返回日期月份中的天数（1到31）
  let hour = nS.getHours() // 返回日期中的小时数（0到23）
  let minute = nS.getMinutes() // 返回日期中的分钟数（0到59）
  let second = nS.getSeconds() // 返回日期中的秒数（0到59）
  month = month < 10 ? '0' + month : month
  date = date < 10 ? '0' + date : date
  hour = hour < 10 ? '0' + hour : hour
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
}
export function getLocalTime3(time) {
  if (time === '') {
    return time
  }
  const nS = new Date(time)
  let year = nS.getFullYear() // 取得4位数的年份
  let month = nS.getMonth() + 1 // 取得日期中的月份，其中0表示1月，11表示12月
  let date = nS.getDate() // 返回日期月份中的天数（1到31）
  // let hour = nS.getHours() // 返回日期中的小时数（0到23）
  // let minute = nS.getMinutes() // 返回日期中的分钟数（0到59）
  month = month < 10 ? '0' + month : month
  date = date < 10 ? '0' + date : date
  // hour = hour < 10 ? '0' + hour : hour
  // minute = minute < 10 ? '0' + minute : minute
  return year + '-' + month + '-' + date
}

export function convertAgentType(type) {
  if (type === '' || type === undefined || type === null) {
    return ''
  }
  if (type === 1) {
    return '头条'
  }
  return '其他'
}
//  FAILED 创建失败，PASS 通过，UNDER 审核中，REJECT 未通过
export function convertComponentStatus(type) {
  let reult = '其他'
  switch (type) {
    case 'FAILED':
      reult = '创建失败'
      break
    case 'PASS':
      reult = '通过'
      break
    case 'UNDER':
      reult = '审核中'
      break
    case 'REJECT':
      reult = '未通过'
      break
  }
  return reult
}
export function convertKeyword(type) {
  let reult = '其他'
  switch (type) {
    case 'PHRASE':
      reult = '短语匹配'
      break
    case 'EXTENSIVE':
      reult = '广泛匹配'
      break
    case 'PRECISION':
      reult = '精准匹配'
      break
  }
  return reult
}
// 2.强制保留2位小数，如：2，会在2后面补上00.即2.00
export function toDecimal2(x) {
  var f = parseFloat(x)
  if (isNaN(f)) {
    return x
  }
  var h = Math.round(x * 100) / 100
  var s = h.toString()
  var rs = s.indexOf('.')
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + 2) {
    s += '0'
  }
  return s
}



// WEBPACK FOOTER //
// ./src/filters/index.js